import { ReactNode, useState } from "react"
import { Button, Flex, Modal } from "antd"
import styles from "./HistoryToolbar.module.scss"

interface HistoryToolbarProps {
  onReverse?: () => void | Promise<void>
  reverseConfirmMessage?: string
  children?: ReactNode
}

const HistoryToolbar: React.FC<HistoryToolbarProps> = ({
  onReverse,
  reverseConfirmMessage,
  children,
}) => {
  const [isReversing, setIsReversing] = useState(false)

  function confirmReverse() {
    Modal.confirm({
      title: "Reverse changes",
      content: reverseConfirmMessage ?? "Reverse the bid changes for the selected period?",
      okText: "Reverse",
      okButtonProps: { danger: true },
      onOk: async () => {
        setIsReversing(true)
        try {
          await onReverse?.()
        } finally {
          setIsReversing(false)
        }
      },
    })
  }

  return (
    <Flex className={styles.toolbar} justify="flex-end" gap="small" wrap>
      {children}
      {onReverse && (
        <Button danger loading={isReversing} onClick={confirmReverse}>
          Reverse changes
        </Button>
      )}
    </Flex>
  )
}

export default HistoryToolbar
